import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolClientAction } from '../symbolClient.action';

export const startSymbolClientProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolClientAction.update.started,
    SymbolClientAction.remove.started,
  ),
  mergeMap(() => {
    return [
      SymbolClientAction.processing.started(),
    ];
  }),
);
